document.addEventListener('DOMContentLoaded', function() {
  setupNavMenu();
});

function setupNavMenu() {
  const navMenuIcon = document.getElementById('nav-menu-icon');
  const navMenuInner = document.getElementById('nav-menu-inner');
  const navMenu = navMenuInner.parentNode; // Assuming the menu container is the parent of navMenuInner
  const links = navMenuInner.querySelectorAll('a'); // Select all anchor links inside the menu

  function toggleNavMenu() {
    navMenuInner.classList.toggle('nav-slide-in');
    
    // Add or remove the dropshadow class
    if (navMenuInner.classList.contains('nav-slide-in')) {
      navMenu.classList.add('add-dropshadow');
      navMenu.style.zIndex = "64";
    } else {
      navMenu.classList.remove('add-dropshadow');
      // Delay removing the z-index by 0.2s
      setTimeout(() => {
        navMenu.style.zIndex = "";
      }, 200); // 200 milliseconds = 0.2 seconds
    }
  }

  // Close the menu when any link inside the menu is clicked
  links.forEach(link => {
    link.addEventListener('click', () => {
      if (navMenuInner.classList.contains('nav-slide-in')) {
        toggleNavMenu(); // This will close the menu and remove the dropshadow
      }
    });
  });

  navMenuIcon.addEventListener('click', toggleNavMenu);
}